/**
 * /poem-generator — одно поле, строка настроек, разбор.
 *
 * Устройство страницы (перестройка 2026-08-24): человек пишет просьбу в одно
 * большое поле и жмёт кнопку. Всё остальное свёрнуто в СТРОКУ СОСТОЯНИЯ —
 * четыре тега, каждый показывает текущее значение своей группы («Форма ·
 * Четверостишия, ямб, 4 стопы, ABAB, 8 строк»). Тег открывает свою панель.
 *
 * Почему состояние, а не пустые поля: развёрнутая анкета на 30 контролов не
 * отвечала на вопрос «что здесь обязательно» — и человек спросил об этом прямо.
 * Пустых полей на экране больше нет, поэтому и вопрос не возникает; а что
 * инструмент собирается сделать по умолчанию, видно, ничего не открывая.
 *
 * Разбор рисуется по данным сервера (RuVerse), а не считается тут заново:
 * второй счётчик слогов в браузере разошёлся бы с тем, по которому чинится
 * стих, и человек видел бы одно, а модель получала другое.
 */
(function () {
    'use strict';

    var CFG = window.__POEM_CFG || {};
    var T = CFG.i18n || {};
    var $ = function (id) { return document.getElementById(id); };
    var form = $('pm-form');
    if (!form) return;

    var out = $('pm-out');
    var poemBox = $('pm-poem');
    var editBox = $('pm-edit');
    var statsBox = $('pm-stats');
    var issuesBox = $('pm-issues');
    var statusEl = $('pm-status');
    var goBtn = $('pm-go');
    var costEl = $('pm-cost');

    // `analysed` — читали ли стих НАШИ приборы. Не то же, что «выбран язык
    // со словарём»: язык мог смениться уже после выдачи. Ответ приносит
    // сервер, и решает он, а не селектор на странице.
    var state = { id: null, text: '', report: null, issues: [], spec: null, analysed: true };

    // ── Память настроек: конструктор не должен обнуляться при перезагрузке ──
    var REMEMBER = ['pm-occasion', 'pm-role', 'pm-gender', 'pm-formsel', 'pm-metre', 'pm-feet',
        'pm-rhyme', 'pm-lines', 'pm-clausula', 'pm-tone', 'pm-style', 'pm-person', 'pm-formality',
        // Язык результата запоминается наравне с остальным: человек, однажды
        // заказавший стих по-английски с русской страницы, обычно делает это
        // снова, а умолчание при первом заходе всё равно ставит сервер по
        // локали страницы.
        'pm-lang'];
    if (window.__toolSettings) {
        REMEMBER.forEach(function (id) {
            var el = $(id);
            if (el) window.__toolSettings.bind('poem-generator', el, id, el.value);
        });
        ['pm-noverb', 'pm-nocliche', 'pm-strict'].forEach(function (id) {
            var el = $(id);
            if (el) window.__toolSettings.bind('poem-generator', el, id, el.checked);
        });
    }

    // ── Примеры под полем ───────────────────────────────────────────────────
    var themeEl = $('pm-theme');
    // Поле растёт под текст (в пределах max-height из CSS): пустой композер не
    // занимает экрана больше, чем весит, а длинная просьба видна целиком.
    function grow() {
        if (!themeEl) return;
        themeEl.style.height = 'auto';
        themeEl.style.height = Math.min(themeEl.scrollHeight + 2, 280) + 'px';
    }
    if (themeEl) {
        themeEl.addEventListener('input', grow);
        grow();
    }

    var seeds = $('pm-seeds');
    if (seeds && themeEl) {
        seeds.addEventListener('click', function (e) {
            var b = e.target.closest('.pm-seed');
            if (!b) return;
            // Вставляем РАЗВЁРНУТЫЙ пример, а не подпись чипа: подпись учит форме
            // запроса, текст — живой детали, ради которой инструмент и нужен.
            themeEl.value = b.dataset.full || b.textContent;
            themeEl.focus();
            themeEl.setSelectionRange(themeEl.value.length, themeEl.value.length);
            grow();
            if (window.__ae) window.__ae('feature_use', { slug: 'poem-generator', f: 'seed' });
        });
    }

    // ── Строка настроек: тег открывает свою панель ──────────────────────────
    var tags = Array.prototype.slice.call(form.querySelectorAll('.pm-tag'));
    tags.forEach(function (tag) {
        tag.addEventListener('click', function () {
            var key = tag.dataset.panel;
            var open = tag.getAttribute('aria-expanded') === 'true';
            // Одна панель за раз: две открытые снова дают полотно, ради ухода
            // от которого всё и затевалось.
            tags.forEach(function (t) {
                t.setAttribute('aria-expanded', 'false');
                var p = $('pm-panel-' + t.dataset.panel);
                if (p) p.hidden = true;
            });
            if (!open) {
                tag.setAttribute('aria-expanded', 'true');
                var panel = $('pm-panel-' + key);
                if (panel) {
                    panel.hidden = false;
                    var first = panel.querySelector('input,select,textarea');
                    if (first) first.focus({ preventScroll: true });
                }
                if (window.__ae) window.__ae('feature_use', { slug: 'poem-generator', f: 'panel_' + key });
            }
        });
    });

    // ── Форма с каноном перекрывает ползунки — и это должно быть ВИДНО ──────
    var CANON = CFG.formCanon || {};
    function canon() { return CANON[$('pm-formsel').value] || null; }
    function syncFixed() {
        var c = canon();
        [['pm-metre', 'metre'], ['pm-feet', 'feet'], ['pm-rhyme', 'rhyme'], ['pm-lines', 'lines']].forEach(function (pair) {
            var el = $(pair[0]);
            if (!el) return;
            var locked = !!c && c[pair[1]] !== null && c[pair[1]] !== undefined;
            el.disabled = locked;
            el.style.opacity = locked ? '.5' : '';
        });
        var note = $('pm-fixed-note');
        if (note) note.hidden = !c;
    }

    // ── Язык РЕЗУЛЬТАТА ────────────────────────────────────────────────────
    /*
     * От него зависит не только сам стих: у языка со словарём заказ
     * проверяется и потому стоит дороже (PoemSpec::costTokens), а у остальных
     * страница обязана снять обещание разбора. Поэтому язык читается тут одной
     * функцией, а не берётся из CFG.lang: CFG.lang — только УМОЛЧАНИЕ, которое
     * сервер поставил по локали страницы.
     */
    function lang() {
        var el = $('pm-lang');
        return (el && el.value) || CFG.lang || 'ru';
    }
    function verifiedLang() {
        return (CFG.verifiedLangs || []).indexOf(lang()) >= 0;
    }

    /**
     * Проверяемый ли заказ. Проверка возможна там, где есть язык со словарём
     * И заданный размер — либо выбранный руками, либо навязанный каноном формы
     * (у сонета он есть, у хайку нет). Отсюда же берётся цена.
     */
    function strictOn() {
        var s = $('pm-strict');
        if (!s || !s.checked || !verifiedLang()) return false;
        var c = canon();
        var metre = c ? c.metre : $('pm-metre').value;
        return !!metre;
    }

    /**
     * Что страница говорит о выбранном языке: есть ли разбор и во что
     * превращается «размер» там, где стоп не считают.
     */
    function syncLang() {
        var code = lang();
        var off = $('pm-verify-off');
        if (off) off.hidden = verifiedLang();

        var note = $('pm-prosody-note');
        if (!note) return;
        var mode = (CFG.prosody || {})[code] || 'accentual';
        var c = canon();
        var metre = c && c.metre !== undefined && c.metre !== null ? c.metre : $('pm-metre').value;
        var feet = c && c.feet ? c.feet : num('pm-feet');
        // Подпись приходит с сервера уже просклонённой («8 слогов», «3 слога»).
        var syl = ((CFG.syllables || {})[metre] || {})[feet];
        if (mode === 'accentual' || !metre || !syl) {
            note.hidden = true;
            note.textContent = '';
            return;
        }
        var tpl = mode === 'quantitative' ? T.prosody_qua : T.prosody_syl;
        if (!tpl) { note.hidden = true; return; }
        note.textContent = tpl.replace(':syl', syl);
        note.hidden = false;
    }

    // ── Тег показывает ЗНАЧЕНИЕ, а не приглашение ───────────────────────────
    function txt(id) { var e = $(id); return e ? String(e.value || '').trim() : ''; }
    function sel(id) {
        var e = $(id);
        if (!e || !e.options) return '';
        var o = e.options[e.selectedIndex];
        return o ? o.textContent.trim() : '';
    }
    function put(id, value, full) {
        var el = $(id);
        if (!el) return;
        el.textContent = value;
        // Полный текст — в подсказке тега: сама строка обрезается многоточием,
        // иначе четыре тега не помещаются в ряд на телефоне.
        var tag = el.closest('.pm-tag');
        if (tag) tag.title = full || value;
    }

    function sumWho() {
        var bits = [];
        var role = txt('pm-role');
        var name = txt('pm-name');
        var occ = txt('pm-occasion');
        if (role) bits.push(role);
        if (name) bits.push(name);
        if (occ) bits.push(occ);
        if (txt('pm-age')) bits.push(txt('pm-age'));
        if (txt('pm-facts')) bits.push('…');
        return bits.length ? bits.join(', ') : (T.sum_who_none || '');
    }

    function sumForm() {
        var c = canon();
        var f = $('pm-formsel').value;
        var bits = [(CFG.formLabels || {})[f] || sel('pm-formsel')];
        var metre = c && c.metre !== null && c.metre !== undefined ? c.metre : $('pm-metre').value;
        var feet = c && c.feet ? c.feet : parseInt($('pm-feet').value, 10) || 0;
        var rhyme = c && c.rhyme ? c.rhyme : $('pm-rhyme').value;
        var lines = c && c.lines ? c.lines : parseInt($('pm-lines').value, 10) || 0;
        if (metre && metre !== 'none') {
            var m = (CFG.metreLabels || {})[metre] || metre;
            bits.push(feet ? m + ', ' + ((CFG.feetLabels || {})[feet] || feet) : m);
        }
        if (rhyme && rhyme !== 'none') bits.push(rhyme);
        else if (rhyme === 'none') bits.push(T.sum_norhyme || '');
        if (lines) bits.push((CFG.linesLabels || {})[lines] || lines);
        return bits.filter(Boolean).join(', ');
    }

    function sumVoice() {
        return [txt('pm-tone'), txt('pm-style'), txt('pm-imagery')].filter(Boolean).join(', ');
    }

    /**
     * «Ещё» — единственная группа, где перечислять нечего: там запреты и
     * свободный текст. Поэтому тег отвечает на другой вопрос: тронуто или нет.
     */
    function sumMore() {
        var touched = !!(txt('pm-must') || txt('pm-avoid') || txt('pm-extra'))
            || !$('pm-noverb').checked || !$('pm-nocliche').checked || !$('pm-strict').checked;
        return touched ? (T.sum_more_on || '') : (T.sum_more_off || '');
    }

    function syncCost() {
        var c = (CFG.costs || {});
        // Строка приходит с сервера УЖЕ просклонённой: форму числительного
        // выбирает trans_choice, повторять её правила в JS для девяти языков
        // значило бы завести второй набор правил, который однажды разойдётся.
        /*
         * У строгого стиха цена зависит от ЧИСЛА СТРОК: сонет стоит нам вдвое
         * дороже четверостишия (замер себестоимости 09.09.2026). Строки берём
         * ПОСЛЕ канона формы — у сонета их 14, что бы ни стояло в поле, — иначе
         * названная цена разойдётся со списанной.
         */
        var pick = c.free;
        if (strictOn()) {
            // ⚠️ txt(), а НЕ val(): val — это `var val = txt` ниже по файлу,
            // то есть на момент первого вызова оно ещё undefined.
            var canon = (CFG.formCanon || {})[txt('pm-formsel')] || {};
            var lines = canon.lines || num('pm-lines') || 0;
            pick = (c.strict_by_lines || {})[lines] || c.strict;
        }
        if (costEl && CFG.enabled && pick) {
            costEl.hidden = false;
            /*
             * Рядом с токенами — ДЕНЬГИ.
             *
             * «1 980 токенов» ничего не говорит тому, кто токенов ещё не
             * покупал. У /video-upscaler это записано ценой возврата №21:
             * человек прочитал «63 000 токенов» рядом с кнопкой за 449 ₽ как
             * «уже оплачено». У стиха это стало важнее 09.09.2026, когда цена
             * перестала быть одним числом и поехала лестницей 1030…2930 по
             * длине.
             *
             * Ставку считает общий примитив (`token-price.js`): она зависит от
             * кассы и последней покупки, поэтому её нельзя запечь в HTML —
             * страница кэшируется, и первый отрендеривший подсунул бы свою
             * валюту всем остальным.
             */
            var money = window.__tokenPrice ? window.__tokenPrice.money(pick.n) : '';
            costEl.textContent = (pick.label || '') + (money ? ' · ' + money : '');
        }
        var hint = $('pm-strict-hint');
        var s = $('pm-strict');
        if (hint && s) hint.textContent = s.checked ? (T.strict_hint || '') : (T.strict_off || '');
    }

    function syncAll() {
        syncFixed();
        syncLang();
        put('pm-sum-who', sumWho());
        put('pm-sum-form', sumForm());
        put('pm-sum-voice', sumVoice());
        put('pm-sum-more', sumMore());
        syncCost();
    }
    // Один слушатель на форму вместо тринадцати именных: любое поле, влияющее
    // на заказ, обязано обновлять свой тег — именной список тихо отстаёт от
    // разметки, стоит добавить контрол.
    form.addEventListener('input', syncAll);
    form.addEventListener('change', syncAll);
    syncAll();

    // Ставка приезжает запросом (она зависит от кассы и последней покупки),
    // поэтому первый syncAll её ещё не застаёт — перерисовываем, когда придёт.
    // Промис примитива никогда не отклоняется: не узнали курс — остаются одни
    // токены, как было до этого.
    if (window.__tokenPrice) window.__tokenPrice.ready().then(syncCost);

    // ── Сбор заказа ─────────────────────────────────────────────────────────
    var val = txt;
    function num(id) { var e = $(id); return e && e.value !== '' ? parseInt(e.value, 10) : 0; }
    /**
     * Подпись → ключ. Комбобоксы отдают ТЕКСТ: человек вправе написать
     * «крёстной» или «как у Хлебникова», и модель это поймёт. Известную подпись
     * приводим к ключу — сервер знает, что с ним делать; незнакомое уезжает как
     * есть, свободным текстом.
     */
    function keyed(id, map) {
        var v = val(id);
        if (!v) return '';
        var m = CFG[map] || {};
        return m[v.toLowerCase()] || v;
    }
    function spec() {
        return {
            lang: lang(),
            theme: val('pm-theme'),
            occasion: val('pm-occasion'),
            recipient_role: keyed('pm-role', 'roleKeys'),
            recipient_name: val('pm-name'),
            recipient_gender: val('pm-gender'),
            recipient_age: num('pm-age') || '',
            from_name: val('pm-from'),
            facts: val('pm-facts'),
            must_words: val('pm-must'),
            avoid_words: val('pm-avoid'),
            form: val('pm-formsel') || 'free',
            metre: val('pm-metre'),
            feet: num('pm-feet'),
            rhyme: val('pm-rhyme') || 'ABAB',
            lines: num('pm-lines'),
            clausula: val('pm-clausula') || 'auto',
            acrostic: val('pm-acrostic'),
            refrain: val('pm-refrain'),
            tone: keyed('pm-tone', 'toneKeys') || 'warm',
            style: keyed('pm-style', 'styleKeys') || 'neutral',
            imagery: val('pm-imagery'),
            person: val('pm-person') || 'auto',
            formality: val('pm-formality') || 'auto',
            no_verb_rhymes: $('pm-noverb').checked ? 1 : 0,
            avoid_cliche: $('pm-nocliche').checked ? 1 : 0,
            strict: $('pm-strict').checked ? 1 : 0,
            extra: val('pm-extra')
        };
    }

    /*
     * Ожидание КОНЕЧНО, и это не украшение.
     *
     * До 2026-09-09 здесь стоял голый fetch без всякого предела. Край при этом
     * закрывает синхронный запрос на 100–120 с, поэтому кнопка «Сочиняю…»
     * зависала навсегда, а человек читал это как «не работает» — ровно так и
     * было написано в обращении #6715, поданном с этой страницы.
     *
     * Предел приходит с сервера (CFG.waitMs ← config/sync-budget.php), чтобы
     * число жило в ОДНОМ месте: браузер не должен ждать дольше, чем транспорт
     * держит соединение, и не должен сдаваться раньше, чем сервер ответит.
     */
    var WAIT_MS = Math.max(15000, (CFG.waitMs || 120000));

    function post(url, body) {
        var ac = window.AbortController ? new AbortController() : null;
        var timer = ac ? setTimeout(function () { ac.abort(); }, WAIT_MS) : null;
        var t0 = Date.now();

        return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': CFG.csrf, 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(body),
            signal: ac ? ac.signal : undefined
        }).then(function (r) {
            if (timer) clearTimeout(timer);
            /*
             * Отказ края (504/502) и страница-заглушка приходят HTML'ом, и
             * r.json() на них ОТКЛОНЯЕТСЯ. Без этого перехвата такой отказ
             * попадал в общий catch и выглядел как обрыв сети — то есть
             * причина терялась ровно там, где она была нужна.
             */
            return r.json().then(
                function (j) { return { status: r.status, json: j, ms: Date.now() - t0 }; },
                function () { return { status: r.status, json: {}, ms: Date.now() - t0, notJson: true }; }
            );
        }, function (err) {
            if (timer) clearTimeout(timer);
            err.__ms = Date.now() - t0;
            err.__timedOut = !!(err && err.name === 'AbortError');
            throw err;
        });
    }

    /*
     * Отказ обязан быть ВИДЕН нам, а не только человеку.
     *
     * Замер 2026-09-09: 466 нажатий «сочинить» в 251 сессии за 16 дней и ОДИН
     * `tool_complete`. Понять по нашей же телеметрии, что происходит с
     * остальными 465, было НЕЛЬЗЯ — путь отказа не слал ничего вовсе, и
     * причину пришлось доставать из логов nginx. Поэтому здесь: одно событие
     * на каждый исход, всегда, с кодом ответа и длительностью.
     */
    function reportFail(kind, extra) {
        try {
            if (typeof window.__ae === 'function') {
                var p = { slug: 'poem-generator', f: 'generate_failed', kind: kind };
                for (var k in (extra || {})) { if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k]; }
                window.__ae('feature_use', p);
            }
        } catch (_) {}
    }

    function say(msg, kind) {
        if (!statusEl) return;
        statusEl.hidden = !msg;
        statusEl.textContent = msg || '';
        statusEl.className = 'pm-note' + (kind === 'warn' ? ' pm-note-warn' : '');
    }

    /** Ответ сервера об отказе → человеческий текст + путь, куда идти. */
    function explain(status, j, ms) {
        reportFail('http', { status: status, err: (j && j.error) || '', ms: ms || 0 });
        if (status === 401) {
            say(T.err_auth, 'warn');
            if (CFG.loginUrl) {
                var a = document.createElement('a');
                a.href = CFG.loginUrl; a.className = 'pm-ghost'; a.textContent = T.err_auth;
                statusEl.textContent = ''; statusEl.appendChild(a);
            }
            return;
        }
        if (status === 402) {
            // Деньги подставляются В САМО число «нужно», а не приписываются к
            // фразе: приписанное «≈ 16 ₽» в конце непонятно к чему относится —
            // к недостающему или к балансу.
            var needMoney = window.__tokenPrice ? window.__tokenPrice.money(j.need || 0) : '';
            var msg = (T.err_tokens || '')
                .replace(':need', String(j.need || '?') + (needMoney ? ' · ' + needMoney : ''))
                .replace(':balance', j.balance || 0);
            say(msg, 'warn');
            if (CFG.buyUrl) {
                var b = document.createElement('a');
                b.href = CFG.buyUrl; b.className = 'pm-ghost'; b.textContent = T.topup;
                // data-tmb-short — стена пополнения знает, сколько не хватает,
                // и сразу подсвечивает подходящий пакет.
                b.setAttribute('data-tmb-short', String(Math.max(0, (j.need || 0) - (j.balance || 0))));
                statusEl.appendChild(document.createTextNode(' '));
                statusEl.appendChild(b);
            }
            return;
        }
        if (status === 429) { say(T.err_throttled, 'warn'); return; }
        if (j && j.error === 'blocked') { say(T.err_blocked, 'warn'); return; }
        if (j && j.error === 'validation') { say(j.msg || T.err_empty, 'warn'); return; }
        say((j && j.msg) || T.err_failed, 'warn');
    }

    // ── Сочинение ───────────────────────────────────────────────────────────
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        // Немой выход по клику — это и есть «кнопка не реагирует». Виден нам,
        // даже когда самой кнопки на странице быть не должно.
        if (!CFG.enabled) { reportFail('disabled', {}); return; }
        var s = spec();
        if (!s.theme && !s.occasion && !s.recipient_role && !s.facts && !s.extra && !s.must_words) {
            say(T.err_empty, 'warn');
            if (themeEl) themeEl.focus();
            return;
        }
        state.spec = s;
        goBtn.disabled = true;
        var old = goBtn.textContent;
        goBtn.textContent = T.generating || '…';
        say(T.stage_draft);
        // Язык результата — в телеметрии: до 11.09.2026 его было негде взять, и
        // вопрос «а заказывают ли вообще не по-русски» не имел ответа.
        if (window.__ae) window.__ae('feature_use', { slug: 'poem-generator', f: 'generate', form: s.form, metre: s.metre || 'auto', strict: s.strict, lang: s.lang });

        post(CFG.genUrl, s).then(function (r) {
            goBtn.disabled = false;
            goBtn.textContent = T.again || old;
            if (r.status !== 200 || !r.json.ok) { explain(r.status, r.json || {}, r.ms); return; }
            say('');
            state.id = r.json.id;
            state.text = r.json.text;
            state.report = r.json.report;
            state.issues = r.json.issues || [];
            state.analysed = !!r.json.analysed;
            render();
            renderAlts(r.json.alts || []);
            out.hidden = false;
            var saved = $('pm-saved');
            if (saved) saved.hidden = false;
            wireDownloads(r.json.id);
            if (window.__aeToolComplete) window.__aeToolComplete({ slug: 'poem-generator', defects: state.issues.length, lang: r.json.lang || s.lang, analysed: state.analysed ? 1 : 0 });
            out.scrollIntoView({ block: 'nearest' });
        }).catch(function (err) {
            goBtn.disabled = false;
            goBtn.textContent = old;
            var timedOut = !!(err && err.__timedOut);
            reportFail(timedOut ? 'timeout' : 'network', {
                ms: (err && err.__ms) || 0,
                msg: String((err && err.message) || '').slice(0, 120)
            });
            // Истёкшее ожидание и оборванная сеть — РАЗНЫЕ вещи для человека:
            // в первом случае повторять сейчас бессмысленно, во втором стоит.
            say(timedOut ? (T.err_timeout || T.err_failed) : T.err_failed, 'warn');
        });
    });

    function wireDownloads(id) {
        [['pm-dl-txt', 'txt'], ['pm-dl-pdf', 'pdf']].forEach(function (pair) {
            var a = $(pair[0]);
            if (!a || !CFG.fileUrl) return;
            a.href = CFG.fileUrl.replace('__ID__', id).replace('__EXT__', pair[1]);
            a.hidden = false;
        });
        var v = $('pm-voice');
        if (v) v.hidden = false;
    }

    // ── Показ стиха с разбором ──────────────────────────────────────────────
    function render() {
        poemBox.textContent = '';
        var rep = state.report || {};
        var lines = rep.lines || [];
        var src = String(state.text || '').split(/\r?\n/);
        var li = 0;

        src.forEach(function (raw) {
            if (raw.trim() === '') {
                var gap = document.createElement('div');
                gap.className = 'pm-gap';
                poemBox.appendChild(gap);
                return;
            }
            var info = lines[li++] || {};
            var wrap = document.createElement('div');
            wrap.className = 'pm-line'
                + ((info.offbeat && info.offbeat.length) || (info.need && info.syl !== info.need) ? ' pm-line-bad' : '')
                + (info.judged === false ? ' pm-line-unjudged' : '');

            var txtEl = document.createElement('span');
            txtEl.className = 'pm-line-txt';
            if (info.words && info.words.length) {
                // Каждое слово — свой столбик: текст сверху, его схема снизу.
                // Так метка стоит ПОД своим словом, и сбитый слог виден без
                // счёта позиций (одной строкой это читалось орнаментом).
                info.words.forEach(function (w, wi) {
                    // Пробел — НАСТОЯЩИЙ текстовый узел, а не отступ в CSS.
                    // Отступом слова выглядели раздельно, но копировались слитно
                    // («Мойдядясамых…»), потому что в разметке между ними ничего
                    // не было. И ставим его по `sp` — по тому, был ли пробел в
                    // исходной строке: выводить это из типа куска мы пробовали
                    // дважды и оба раза ошибались («нев шутку», «вышло— не»).
                    if (wi > 0 && w.sp !== false) {
                        txtEl.appendChild(document.createTextNode(' '));
                    }
                    var col = document.createElement('span');
                    col.className = 'pm-w';
                    var a = document.createElement('span');
                    a.className = 'pm-wt';
                    a.textContent = w.t;
                    col.appendChild(a);
                    if (w.m) {
                        var bm = document.createElement('span');
                        bm.className = 'pm-wm';
                        // Разбор — не часть стиха: скринридер обязан читать
                        // строку, а не диктовать значки под каждым словом.
                        bm.setAttribute('aria-hidden', 'true');
                        bm.textContent = w.m;
                        col.appendChild(bm);
                    }
                    txtEl.appendChild(col);
                });
                if (info.judged === false) txtEl.title = T.unjudged || '';
            } else {
                txtEl.textContent = raw;
            }
            wrap.appendChild(txtEl);
            if (CFG.enabled && info.n) {
                var btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'pm-relink';
                btn.textContent = T.reline || '';
                btn.addEventListener('click', function () { openReline(info.n, wrap); });
                // Кнопка — СОСЕД текста строки, а не её часть: внутри она
                // попадала в выделение и «…правилПереписать строку» уезжало в
                // буфер вместе со стихом.
                wrap.appendChild(btn);
            }
            poemBox.appendChild(wrap);
        });

        renderStats(rep);
        renderIssues();
    }

    function stat(label, value, cls) {
        var s = document.createElement('span');
        s.className = 'pm-stat' + (cls ? ' ' + cls : '');
        s.appendChild(document.createTextNode(label + ' '));
        var b = document.createElement('b');
        b.textContent = value;
        s.appendChild(b);
        return s;
    }

    function renderStats(rep) {
        statsBox.textContent = '';
        if (!rep) return;
        /*
         * `metre: null` — это «разбора не было», а не «размер не определился».
         * Такой отчёт приходит с языка, которого наши приборы не знают
         * (PoemCritic::blindReport), и печатать по нему «в размере 4 / 4» и
         * «рифм 0 / 2» было бы выдумкой: оба числа — артефакт русского словаря
         * на латинице. Акростих при этом считается и показывается: это первые
         * БУКВЫ строк, они одинаковы на любом языке.
         */
        if (rep.metre) {
            var mName = rep.metre.ru && rep.metre.ru !== T.undetermined ? rep.metre.ru : (T.undetermined || '');
            statsBox.appendChild(stat(T.metre + ':', mName + (rep.metre.feet ? ', ' + rep.metre.feet : '')));
        }
        if (rep.scheme) statsBox.appendChild(stat(T.scheme + ':', rep.scheme));
        if (rep.judged) {
            var ok = rep.in_metre === rep.judged;
            statsBox.appendChild(stat(T.inmetre + ':', rep.in_metre + ' / ' + rep.judged, ok ? 'pm-stat-ok' : 'pm-stat-bad'));
        }
        if (rep.pairs && rep.pairs.length) {
            var rok = rep.in_rhyme === rep.pairs.length;
            statsBox.appendChild(stat(T.rhymes + ':', rep.in_rhyme + ' / ' + rep.pairs.length, rok ? 'pm-stat-ok' : 'pm-stat-bad'));
        }
        if (rep.acrostic) {
            statsBox.appendChild(stat(T.acrostic + ':', rep.acrostic.ok ? T.acr_ok : T.acr_no + ' (' + rep.acrostic.got + ')',
                rep.acrostic.ok ? 'pm-stat-ok' : 'pm-stat-bad'));
        }
    }

    function renderIssues() {
        issuesBox.textContent = '';
        /*
         * «Нарушений нет» — утверждение о ПРОВЕРКЕ, а не о её отсутствии. Там,
         * где разбора не было, пустой список означает «не смотрели», и печатать
         * по нему зелёную строчку значило бы обещать проверку, которой на этом
         * языке нет, — на той же странице, где мы честно пишем обратное.
         */
        if (!state.analysed) { issuesBox.hidden = true; return; }
        if (!state.issues.length) {
            issuesBox.hidden = false;
            var p = document.createElement('p');
            p.className = 'pm-note';
            p.textContent = T.clean || '';
            issuesBox.appendChild(p);
            return;
        }
        issuesBox.hidden = false;
        var h = document.createElement('h4');
        h.textContent = T.issues || '';
        issuesBox.appendChild(h);
        var ul = document.createElement('ul');
        state.issues.forEach(function (x) {
            var li = document.createElement('li');
            li.textContent = x;
            ul.appendChild(li);
        });
        issuesBox.appendChild(ul);
    }

    function renderAlts(alts) {
        var box = $('pm-alts');
        var list = $('pm-alts-list');
        if (!box || !list) return;
        list.textContent = '';
        if (!alts.length) { box.hidden = true; return; }
        box.hidden = false;
        alts.forEach(function (a) {
            var card = document.createElement('div');
            card.className = 'pm-alt';
            var pre = document.createElement('pre');
            pre.textContent = a.text;
            card.appendChild(pre);
            var meta = document.createElement('span');
            meta.className = 'pm-stat' + (a.defects ? ' pm-stat-bad' : ' pm-stat-ok');
            meta.textContent = a.defects ? (T.alt_defects || '').replace(':n', a.defects) : (T.alt_clean || '');
            card.appendChild(meta);
            var use = document.createElement('button');
            use.type = 'button';
            use.className = 'pm-ghost';
            use.style.marginInlineStart = '8px';
            use.textContent = T.use_alt || '';
            use.addEventListener('click', function () {
                state.text = a.text;
                reanalyze();
                out.scrollIntoView({ block: 'nearest' });
            });
            card.appendChild(use);
            list.appendChild(card);
        });
    }

    // ── Правка руками: разбор пересчитывается на сервере тем же кодом ───────
    var editing = false;
    poemBox.addEventListener('dblclick', function () { toggleEdit(true); });
    function toggleEdit(on) {
        editing = on;
        poemBox.hidden = on;
        editBox.hidden = !on;
        if (on) { editBox.value = state.text; editBox.focus(); }
    }
    var tick = null;
    editBox.addEventListener('input', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
            state.text = editBox.value;
            reanalyze();
        }, 600);
    });
    editBox.addEventListener('blur', function () {
        state.text = editBox.value;
        reanalyze().then(function () { toggleEdit(false); });
    });

    function reanalyze() {
        var s = state.spec || spec();
        s.text = state.text;
        return post(CFG.analyzeUrl, s).then(function (r) {
            if (r.status === 200 && r.json.ok) {
                state.report = r.json.report;
                state.issues = r.json.issues || [];
                state.analysed = !!r.json.analysed;
                if (!editing) render(); else { renderStats(state.report); renderIssues(); }
            }
        }).catch(function () {});
    }

    // ── Переписать одну строку ──────────────────────────────────────────────
    // Инлайновая строка под самим стихом, а не window.prompt: диалог браузера
    // закрывает ту самую строку, которую человек правит, а во встроенных
    // webview его иногда просто не показывают.
    function openReline(n, lineEl) {
        var open = poemBox.querySelector('.pm-relbox');
        if (open) open.remove();
        var box = document.createElement('div');
        box.className = 'pm-relbox';

        var row = document.createElement('div');
        row.className = 'pm-reline';
        var inp = document.createElement('input');
        inp.className = 'pm-input';
        inp.maxLength = 300;
        inp.placeholder = T.reline_ph || '';
        inp.setAttribute('aria-label', T.reline_wish || '');
        var go = document.createElement('button');
        go.type = 'button';
        go.className = 'lg-btn pm-btn-sm';
        go.textContent = T.reline_go || '';
        var fire = function () { box.remove(); doReline(n, inp.value); };
        go.addEventListener('click', fire);
        inp.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); fire(); }
            if (e.key === 'Escape') box.remove();
        });
        row.appendChild(inp);
        row.appendChild(go);
        box.appendChild(row);
        lineEl.appendChild(box);
        inp.focus();

        suggestRhymes(n, box, inp);
    }

    /**
     * Подсказка рифмы — ЗДЕСЬ, а не отдельной панелью.
     *
     * Словарь рифм на странице был, но стоял сам по себе, никак не связанный
     * со стихом: человек резонно сказал, что «Подобрать рифму» к инструменту не
     * относится. Относится, если спрашивать в нужный момент: у переписываемой
     * строки есть ПАРА, её концовка известна из разбора — значит и вопрос
     * конкретный («чем закончить, чтобы срифмовалось с „окно“»), и ответ сразу
     * вставляется в пожелание.
     */
    function suggestRhymes(n, box, wishInput) {
        var rep = state.report || {};
        var pairs = rep.pairs || [];
        var partner = null;
        for (var i = 0; i < pairs.length; i++) {
            if (pairs[i].a === n) { partner = { n: pairs[i].b, word: pairs[i].wb }; break; }
            if (pairs[i].b === n) { partner = { n: pairs[i].a, word: pairs[i].wa }; break; }
        }
        if (!partner || !partner.word || !CFG.rhymeUrl) return;

        post(CFG.rhymeUrl, { word: partner.word, limit: 14, strict: 1 }).then(function (r) {
            if (!box.isConnected) return;                 // строку уже закрыли
            if (r.status !== 200 || !r.json.ok || !r.json.rhymes.length) return;
            var wrap = document.createElement('div');
            wrap.className = 'pm-rhymes';
            var lab = document.createElement('span');
            lab.className = 'pm-rhymes-l';
            lab.textContent = (T.rhyme_for || '').replace(':n', partner.n).replace(':word', partner.word);
            wrap.appendChild(lab);
            r.json.rhymes.forEach(function (w) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'pm-rh-w';
                b.textContent = w;
                b.addEventListener('click', function () {
                    wishInput.value = (T.rhyme_wish || '').replace(':word', w);
                    wishInput.focus();
                    if (window.__ae) window.__ae('feature_use', { slug: 'poem-generator', f: 'rhyme_pick' });
                });
                wrap.appendChild(b);
            });
            box.appendChild(wrap);
        }).catch(function () {});
    }

    function doReline(n, wish) {
        var body = state.spec ? Object.assign({}, state.spec) : spec();
        body.poem = state.text;
        body.line = n;
        body.wish = wish;
        say(T.generating);
        post(CFG.relineUrl, body).then(function (r) {
            if (r.status !== 200 || !r.json.ok) { explain(r.status, r.json || {}); return; }
            say('');
            var src = state.text.split(/\r?\n/);
            var seen = 0;
            for (var i = 0; i < src.length; i++) {
                if (src[i].trim() === '') continue;
                if (++seen === n) { src[i] = r.json.text; break; }
            }
            state.text = src.join('\n');
            reanalyze();
        }).catch(function () { say(T.err_failed, 'warn'); });
    }

    // ── Схема ударений: показать или убрать ─────────────────────────────────
    var scanBtn = $('pm-scan');
    if (scanBtn && window.__toolSettings) {
        var applyScan = function (on) {
            poemBox.classList.toggle('pm-poem-plain', !on);
            scanBtn.classList.toggle('pm-ghost-on', on);
            scanBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        };
        applyScan(window.__toolSettings.load('poem-generator', 'scan', true) !== false);
        scanBtn.addEventListener('click', function () {
            var on = scanBtn.getAttribute('aria-pressed') !== 'true';
            applyScan(on);
            window.__toolSettings.save('poem-generator', 'scan', on);
            if (window.__ae) window.__ae('feature_use', { slug: 'poem-generator', f: 'scan_' + (on ? 'on' : 'off') });
        });
    }

    /* ── «Мои стихи»: открыть сохранённый прямо здесь ──────────────────────
     *
     * Разбор нового стиха НЕ заказывается: он приходит от БЕСПЛАТНОГО
     * `/api/poem/analyze` (наш словарь, нам ничего не стоит), поэтому
     * открыть свой стих можно сколько угодно раз и это не трогает кошелёк.
     * Тем же вызовом гарантируется, что разбор посчитан текущим RuVerse, а
     * не тем, что лежал в базе три месяца назад.
     */
    var mine = document.getElementById('pm-mine');
    if (mine) {
        mine.addEventListener('click', function (e) {
            var b = e.target && e.target.closest ? e.target.closest('.pm-mine-open') : null;
            if (!b) return;
            var item = b.closest('.pm-mine-item');
            var pre = item && item.querySelector('.pm-mine-text');
            if (!pre) return;

            state.id = b.getAttribute('data-id');
            state.text = pre.textContent;
            state.spec = {
                lang: b.getAttribute('data-lang') || CFG.lang,
                metre: b.getAttribute('data-metre') || null,
                feet: parseInt(b.getAttribute('data-feet'), 10) || 0,
                rhyme: b.getAttribute('data-rhyme') || 'none',
                lines: parseInt(b.getAttribute('data-lines'), 10) || 0,
                strict: 1
            };
            state.report = null;
            state.issues = [];
            out.hidden = false;
            renderAlts([]);
            wireDownloads(state.id);
            reanalyze();
            if (window.__ae) window.__ae('feature_use', { slug: 'poem-generator', f: 'mine_open' });
            // block:'nearest' — не дёргать страницу, если блок и так виден.
            out.scrollIntoView({ block: 'nearest' });
        });
    }

    // ── Копирование ─────────────────────────────────────────────────────────
    var copyBtn = $('pm-copy');
    if (copyBtn) {
        copyBtn.addEventListener('click', function () {
            navigator.clipboard.writeText(state.text || '').then(function () {
                var old = copyBtn.textContent;
                copyBtn.textContent = T.copied || '✓';
                setTimeout(function () { copyBtn.textContent = old; }, 1600);
            });
        });
    }
})();
